import React, { useEffect, useState } from "react";
import NavBar from "../navbar";
import LoadingMain from "../../components/LoadingMain";

import ProfileIcon from "../../assets/profile.png";
import config from "../../config";

import { useNavigate, redirect, useParams } from 'react-router-dom';
import * as contentful from 'contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import NotFound from "../../components/notFound";
import { set } from "date-fns";
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types';
import RelatedArticles from "./relatedArticles";
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid'





export default function BlogPage() {



  const [includes, setIncludes] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [item, setItem] = useState(null);

  const [loading, setLoading] = useState(false);
  const [errResponse, setErrResponse] = useState("");
  const [notFound, setNotFound] = useState(false);


  function isSpaceOrChidlren(children) {
      if(children.length == 1 && children[0] == '') {
        return <br />
      }
      return children
  }

  const options = {
    renderNode: {
      [BLOCKS.DOCUMENT]: (_, children) => <>{children}</>,
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <p style={{ marginBottom: "1rem", fontSize: "1rem", color: "#333" }}>
          {isSpaceOrChidlren(children)}
        </p>
      ),
      [BLOCKS.HEADING_1]: (_, children) => (
        <h1 style={{ fontSize: "2.25rem", fontWeight: "700", marginBottom: "1rem" }}>
          {isSpaceOrChidlren(children)}
        </h1>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <h2 style={{ fontSize: "1.875rem", fontWeight: "600", marginBottom: "1rem" }}>
          {isSpaceOrChidlren(children)}
        </h2>
      ),
      [BLOCKS.HEADING_3]: (_, children) => (
        <h3 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "0.75rem" }}>
          {isSpaceOrChidlren(children)}
          </h3>
      ),
      [BLOCKS.HEADING_4]: (_, children) => (
        <h4 style={{ fontSize: "1.25rem", fontWeight: "600", marginBottom: "0.5rem" }}>
          {isSpaceOrChidlren(children)}
          </h4>
      ),
      [BLOCKS.HEADING_5]: (_, children) => (
        <h5 style={{ fontSize: "1.125rem", fontWeight: "500", marginBottom: "0.5rem" }}>
          {isSpaceOrChidlren(children)}
          </h5>
      ),
      [BLOCKS.HEADING_6]: (_, children) => (
        <h6 style={{ fontSize: "1rem", fontWeight: "500", marginBottom: "0.5rem" }}>
          {isSpaceOrChidlren(children)}
          </h6>
      ),
      [BLOCKS.UL_LIST]: (_, children) => (
        <ul style={{ paddingLeft: "1.5rem", listStyleType: "disc", marginBottom: "1rem" }}>
          {children}
        </ul>
      ),
      [BLOCKS.OL_LIST]: (_, children) => (
        <ol style={{ paddingLeft: "1.5rem", listStyleType: "decimal", marginBottom: "1rem" }}>
          {children}
        </ol>
      ),
      [BLOCKS.LIST_ITEM]: (_, children) => <li style={{ marginBottom: "0.25rem" }}>{children}</li>,
      [BLOCKS.QUOTE]: (_, children) => (
        <blockquote style={{ borderLeft: "4px solid #ccc", paddingLeft: "1rem", color: "#666", fontStyle: "italic", marginBottom: "1rem" }}>
          {children}
        </blockquote>
      ),
      [BLOCKS.HR]: () => <hr style={{ margin: "2rem 0", borderColor: "#ddd" }} />,
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        const { file, title } = node.data.target.fields;
        const imageUrl = getAssetImageUrl(node.data.target.sys.id);
        return (
          <img
            src={imageUrl}
            alt={title || ""}
            width={file.details.image.width}
            height={file.details.image.height}
            style={{
              borderRadius: "0.5rem",
              width: "100%",
              objectFit: "cover",
              marginBottom: "1rem"
            }}
          />
        );
      },
      [BLOCKS.EMBEDDED_ENTRY]: () => (
        <div style={{ border: "1px dashed #ccc", padding: "1rem", marginBottom: "1rem" }}>
          Embedded Entry Placeholder
        </div>
      ),
      [BLOCKS.EMBEDDED_RESOURCE]: () => (
        <div style={{ backgroundColor: "#f0f0f0", padding: "1rem", marginBottom: "1rem" }}>
          Embedded Resource Placeholder
        </div>
      ),

      [BLOCKS.TABLE]: (_, children) => (
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "1rem" }}>
          {children}
        </table>
      ),
      [BLOCKS.TABLE_ROW]: (_, children) => (
        <tr style={{ borderBottom: "1px solid #ddd" }}>{children}</tr>
      ),
      [BLOCKS.TABLE_CELL]: (_, children) => (
        <td style={{ padding: "0.5rem", border: "1px solid #ddd" }}>{children}</td>
      ),

      
      [INLINES.HYPERLINK]: (node, children) => (
        <a href={node.data.uri} style={{ color: "#3b82f6", textDecoration: "underline" }}>
          {children}
        </a>
      ),
      [INLINES.ENTRY_HYPERLINK]: () => (
        <a href="#" style={{ color: "#3b82f6", fontWeight: "500" }}>
          Linked Entry Placeholder
        </a>
      ),
      [INLINES.ASSET_HYPERLINK]: () => (
        <a href="#" style={{ color: "#3b82f6", fontStyle: "italic" }}>
          Linked Asset Placeholder
        </a>
      ),
      [INLINES.RESOURCE_HYPERLINK]: () => (
        <a href="#" style={{ color: "#3b82f6", textDecoration: "underline" }}>
          Linked Resource Placeholder
        </a>
      ),
      
      [INLINES.EMBEDDED_ENTRY]: () => (
        <span style={{ backgroundColor: "#eef", padding: "0.2rem 0.4rem", borderRadius: "0.2rem" }}>
          Inline Embedded Entry
        </span>
      ),
      [INLINES.EMBEDDED_RESOURCE]: () => (
        <span style={{ backgroundColor: "#efe", padding: "0.2rem 0.4rem", borderRadius: "0.2rem" }}>
          Inline Embedded Resource
        </span>
      ),
      
    },
  
    renderMark: {
      [MARKS.BOLD]: (text) => <strong>{text}</strong>,
      [MARKS.ITALIC]: (text) => <em>{text}</em>,
      [MARKS.UNDERLINE]: (text) => (
        <span style={{ textDecoration: "underline" }}>{text}</span>
      ),
      [MARKS.CODE]: (text) => (
        <code
          style={{
            backgroundColor: "#f5f5f5",
            padding: "0.2rem 0.4rem",
            borderRadius: "0.25rem",
            fontFamily: "monospace",
          }}
        >
          {text}
        </code>
      ),
      [MARKS.SUPERSCRIPT]: (text) => (
        <sup>{text}</sup>
      ),
      [MARKS.SUBSCRIPT]: (text) => (
        <sub>{text}</sub>
      ),
      [MARKS.STRIKETHROUGH]: (text) => (
        <span style={{ textDecoration: "line-through" }}>{text}</span>
      ),
    },
  
    preserveWhitespace: true
  };
  
  

  const { slug } = useParams();

  const client = contentful.createClient(config.contentfulConfig);


  const author = {
    name: 'Sid Thiru',
    role: 'Co-Founder',
    href: '#',
    description: 'I’m a music enthusiast who built MusicPorter to solve a problem I’ve faced myself—managing music across different platforms shouldn’t be a hassle. '
  }


  useEffect(() => {

    const fetchData = async () => {
      setLoading(true);
      client.getEntries({
        content_type: 'blog',
        'fields.slug[match]': slug,
        include: 1
      })
        .then((entries) => {
          if (entries["total"] === 0) {
            console.log("No blog content found");
            setNotFound(true)
            setLoading(false)
            return;
          }
          let entry = undefined

          entries.items.forEach((p) => {
            if (p.fields.slug === slug) {
              setItem(p);
              entry = p;
            }
          });

          if (entry === undefined) {
            console.log("No blog content found");
            setNotFound(true)
            setLoading(false)
            return;
          }

          setNotFound(false)
          setIncludes(entries.includes);



          return entry;
        })
        .then((entry) => {
          setLoading(false)
          setTitle(entry.fields.title);
          setBannerImage(entry.fields.bannerImage);
          setItem(entry);
          setDescription(entry.fields.blogContent)

        })
        .catch((error) => {
          setErrResponse(error.message)
          console.error('Error fetching data:', error);
          setLoading(false)
        })
        .finally(() => {
          setLoading(false); // Set loading state to false after fetch completes
        }
        );

    };

    fetchData();
  }, []);


  function getAssetImageUrl(id) {
    
    const asset = includes.Asset.find(asset => asset.sys.id === id);
    if (asset) {
      return `https:${asset.fields.file.url}`;
    }
    return null;
  }


  function getRelatedArticleIds() {
      const relatedArticleIds = [];

      if (item["fields"]["relatedArticles"] && item["fields"]["relatedArticles"].length > 0) {
        item["fields"]["relatedArticles"].forEach((i) => {
        relatedArticleIds.push(i["sys"]["id"])
      })
    }

      return relatedArticleIds
    }


    function Breadcrumbs() {
      return (
        <nav aria-label="Breadcrumb" className="flex">
          <ol role="list" className="flex items-center space-x-4">
            <li>
              <div>
                <a href={config.appUrl} className="text-gray-400 hover:text-gray-500">
                  <HomeIcon aria-hidden="true" className="size-5 shrink-0" />
                  <span className="sr-only">Home</span>
                </a>
              </div>
            </li>

            <li >
                <div className="flex items-center">
                  <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                  <a
                    href={config.appUrl + config.blogPath}
                    
                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                  >
                    Blog
                  </a>
                </div>
              </li>

            <li >
                <div className="flex items-center">
                  <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                  <a
                    href={"#"}
                    aria-current={'page' }
                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                  >
                    {title}
                  </a>
                </div>
              </li>
          </ol>
        </nav>
      )
    }
    


  function BlogPageContent() {
    return (
      <>
        <div className="bg-white px-6 py-8 lg:px-8">
          <div className="mx-auto max-w-3xl text-base/7 text-gray-700">

          <div className="py-4"><Breadcrumbs ></Breadcrumbs></div>

            <div>
              <h1 id="blogTitle" className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl">
                {title}
              </h1>
            </div>

            <div className="mt-8 flex items-center gap-x-4 text-xs">
              <time id="updatedTime" dateTime={item["sys"]["updatedAt"]} className="text-gray-500">
                Last Updated: {new Date(item["sys"]["updatedAt"]).toLocaleDateString('en-US', { month: 'short', year: 'numeric', day: 'numeric' })}
              </time>
              
              <a
              id="categoryTags"
                href={"#"}
                className="rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100"
              >
                {item["metadata"]["tags"].map((item) => (
                  <span key={item["sys"]["id"]}>{item["sys"]["id"]}</span>
                ))}

              </a>
            </div>

            <>
              <figure className="mt-16">
                <img
                  alt="Blog cover"
                  src={getAssetImageUrl(item["fields"]["coverImage"]["sys"]["id"])}
                  className="aspect-video rounded-xl bg-gray-50 object-cover"
                />
              </figure>
            </>


            <div className="mt-16" id="blogContent">
              {documentToReactComponents(description, options)}
            </div>

            

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">About Author</h2>
            

            <div className="mt-8 flex items-center gap-x-4">
              <img alt="" src={ProfileIcon} className="rounded-full bg-gray-100" style={{ width: '50px', height: '50px' }} />

              <div className="text-sm/6">
                <p className="font-semibold text-gray-900">
                    
                    {author.name}
                </p>
                <p className="text-gray-600">{author.role}</p>
                <p className="text-gray-600 mt-2">{author.description}</p>
              </div>
            </div>

            {getRelatedArticleIds().length > 0 && <RelatedArticles entryIds={getRelatedArticleIds()}></RelatedArticles>}


          </div>
        </div>
      </>
    )
  }


  function BlogPageView() {
    return (

      <>

        <>
          {/* Start block */}
          <section className="bg-white py-24 sm:py-32">
            <div className="">
              {
                notFound ?
                  (<NotFound isDashboard={false}/>) : (item && (BlogPageContent()))
              }
            </div>
          </section>
          {/* End block */}
        </>


      </>

    )


  }


  // render the fetched Contentful data
  return (
    <>



      {loading ? <LoadingMain />
        : <>{BlogPageView()}</>
      }



      {/* Start block */}
      <section className="bg-gray-50 dark:bg-zinc-800">
        <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
          <div className="max-w-screen-sm mx-auto text-center">
            <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
              Start your transfer for free
            </h2>
            <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">

            </p>
            <a
              href={config.signupPath}
              className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800"
            >
              Sign up
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
